<template>
  <a-select
      v-show="info.status === 'edit'"
      v-model:value="data[propName]"
      :allowClear="true"
      :placeholder="'请填写' + info.title"
      style="width: 100%"
  >
    <a-select-option v-for="option in widget.options" :key="option.value" :value="option.value">
      {{ option.name }}
    </a-select-option>
  </a-select>
  <div v-show="info.status=== 'show'" class="view">
    {{ widget.options.find(i => i.value === data[propName])?.name || '' }}
  </div>
</template>

<script lang="ts" setup>
import {defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {SelectFieldType} from "@/components/business/crud/interface/FieldType";


const props = defineProps<{
  propName: string;
  widget: SelectFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
</script>


<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
